import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=043c59e8&scoped=true&"
import script from "./productCategory.vue?vue&type=script&lang=js&"
export * from "./productCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c59e8",
  null
  
)

export default component.exports